<template>
  <div>
    <!-- Sidebar with Content -->
    <v-card
      v-if="hasSelection"
      outlined
      class="details-sidebar rounded-t-md"
      elevation="2"
      :height="sidebarHeight"
    >
      <chart-details-content
        :details="details"
        content-style="overflow-y: auto; flex: 1;"
        @close="$emit('close')"
      >
        <template v-slot:content>
          <slot name="content"></slot>
        </template>
      </chart-details-content>
    </v-card>

    <!-- Empty State -->
    <v-card
      v-else
      outlined
      class="details-sidebar empty-state"
      elevation="0"
      :height="sidebarHeight"
    >
      <v-card-text
        class="d-flex flex-column justify-center align-center fill-height grey--text text--lighten-1"
      >
        <v-icon size="64" color="grey lighten-2">mdi-chart-box-outline</v-icon>
        <div class="mt-4 text-center text-body-2">
          Wählen Sie ein Diagramm oder
        </div>
        <div class="text-center text-body-2">
          eine Datenreihe für weitere Details
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ChartDetailsContent from "./ChartDetailsContent.vue";

export default {
  name: "ChartDetailsSidebar",
  components: {
    ChartDetailsContent,
  },
  props: {
    details: {
      type: Object,
      default: () => ({}),
    },
    sidebarHeight: {
      type: String,
      default: "calc(100vh - 200px)",
    },
  },
  computed: {
    hasSelection() {
      return this.details && Object.keys(this.details).length > 0;
    },
  },
};
</script>

<style scoped>
.details-sidebar {
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 80px;
}

.scrollable-content {
  overflow-y: auto;
  flex: 1;
}

.empty-state {
  background-color: #fafafa;
}

.theme--dark .empty-state {
  background-color: #1e1e1e;
}
</style>
